var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.103329 0.236665C-0.0266711 0.366665 -0.0266711 0.576665 0.103329 0.706665L1.39666 2L0.103329 3.29333C-0.0266711 3.42333 -0.0266711 3.63333 0.103329 3.76333C0.233329 3.89333 0.443329 3.89333 0.573329 3.76333L2.10333 2.23333C2.23333 2.10333 2.23333 1.89333 2.10333 1.76333L0.573329 0.233332C0.446662 0.106665 0.233329 0.106665 0.103329 0.236665ZM2.09747 0.236665C1.96747 0.366665 1.96747 0.576665 2.09747 0.706665L3.3908 2L2.09747 3.29333C1.96747 3.42333 1.96747 3.63333 2.09747 3.76333C2.22747 3.89333 2.43747 3.89333 2.56747 3.76333L4.09747 2.23333C4.22747 2.10333 4.22747 1.89333 4.09747 1.76333L2.56747 0.233332C2.4408 0.106665 2.22747 0.106665 2.09747 0.236665ZM4.09747 0.706665C3.96747 0.576665 3.96747 0.366665 4.09747 0.236665C4.22747 0.106665 4.4408 0.106665 4.56747 0.233332L6.09747 1.76333C6.22747 1.89333 6.22747 2.10333 6.09747 2.23333L4.56747 3.76333C4.43747 3.89333 4.22747 3.89333 4.09747 3.76333C3.96747 3.63333 3.96747 3.42333 4.09747 3.29333L5.3908 2L4.09747 0.706665Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeRightArrow);
export default __webpack_public_path__ + "static/media/three-right-arrow.ada98eb6.svg";
export { ForwardRef as ReactComponent };